import {FC} from 'react';
import {IDocumentQueueActions, IDocumentQueueItem} from '@kcast-fe/core';
import {Box} from '@chakra-ui/react';

import {DocDropzone, DocQueueErrors} from './components';

interface IProps {
  queue: Array<IDocumentQueueItem>;
  queueActions: IDocumentQueueActions;
}

const DocumentUploaderFC: FC<IProps> = ({queue, queueActions}) => {
  return (
    <Box p={'0 24px 8px 24px'}>
      {/* ERROR FILES */}
      <DocQueueErrors queueErrors={queue.filter((q) => q.isError)} />

      {/* UPLOAD A NEW FILE */}
      <DocDropzone onFileError={queueActions.addQueueItem} onSelectFile={queueActions.doUpload} />
    </Box>
  );
};

export const DocumentUploader = DocumentUploaderFC;
